<template>
  <div
    class="flex flex-col gap-4 rounded-[20px] bg-white-gray p-4 lg:gap-5 lg:p-5"
  >
    <div class="flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center lg:flex-nowrap">
      <div class="flex flex-wrap gap-2 md:flex-1">
        <SettingsNavBarButton
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          :selected="isActive(item)"
        >
          {{ item.label }}
        </SettingsNavBarButton>
      </div>

      <button
        type="button"
        class="inline-flex items-center justify-center self-start rounded-[999px] bg-white px-4 py-2.5 text-center text-[14px] leading-[1.15] text-gray-dark transition-colors cursor-pointer md:ml-auto md:self-auto lg:rounded-[10px] lg:px-[30px] lg:text-[18px]"
        aria-label="Выход"
        :disabled="isLoggingOut"
        @click="handleLogout"
      >
        Выход
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, useNuxtApp, useRoute, useRouter } from "#imports";
import { useAuthBootstrap } from "~/composables/useAuthBootstrap";
import { useLoginResponse } from "~/composables/useLoginResponse";
import SettingsNavBarButton from "~/components/settings/SettingsNavBarButton.vue";

type NavItem = {
  label: string;
  to: string;
  exact?: boolean;
};

const navItems: NavItem[] = [
  { label: "Ваши данные", to: "/profile", exact: true },
  { label: "Адреса доставки", to: "/profile/delivery" },
  // { label: "Склады", to: "/profile/warehouse" },
  // { label: "Свои наценки", to: "/profile/markups" },
  { label: "Сменить пароль", to: "/profile/change-password" },
];

const normalizePath = (path: string) => path.replace(/\/+$/, "") || "/";
const route = useRoute();
const router = useRouter();
const nuxtApp = useNuxtApp();
const { markUnauthorized } = useAuthBootstrap();
const { clearLoginResponse } = useLoginResponse();
const $useOneCApi = nuxtApp.$useOneCApi as (
  action: string,
  payload?: Record<string, any>,
) => Promise<unknown>;
const isLoggingOut = ref(false);

const currentPath = computed(() => normalizePath(route.path));
const isActive = (item: NavItem) => {
  const normalizedTarget = normalizePath(item.to);
  if (item.exact) {
    return currentPath.value === normalizedTarget;
  }
  return (
    currentPath.value === normalizedTarget ||
    currentPath.value.startsWith(`${normalizedTarget}/`)
  );
};

const handleLogout = async () => {
  if (isLoggingOut.value || typeof $useOneCApi !== "function") {
    return;
  }

  isLoggingOut.value = true;

  try {
    await $useOneCApi("loginout");
  } catch (error) {
    console.error("Failed to logout", error);
  } finally {
    markUnauthorized();
    clearLoginResponse();

    if (process.client) {
      localStorage.removeItem("guid");
    }

    await router.push("/login");
    isLoggingOut.value = false;
  }
};
</script>
